export default __webpack_public_path__ + "static/media/outcess15.1181beb8.jpg";